"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMMemberAccessCompiler = void 0;
const inversify_1 = require("inversify");
const IVMCompilerUtils_1 = require("../../../../interfaces/vm-transformers/IVMCompilerUtils");
const ServiceIdentifiers_1 = require("../../../../container/ServiceIdentifiers");
const VMOpCode_1 = require("../../../../enums/vm-transformers/VMOpCode");
const NodeGuards_1 = require("../../../../node/NodeGuards");
let VMMemberAccessCompiler = class VMMemberAccessCompiler {
    compileMemberExpression(node, context) {
        var _a, _b, _c;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        if (NodeGuards_1.NodeGuards.isSuperNode(node.object)) {
            builder.this();
            if (node.computed) {
                (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(node.property);
            }
            else {
                if (NodeGuards_1.NodeGuards.isIdentifierNode(node.property)) {
                    builder.loadConst(node.property.name);
                }
            }
            builder.emitRaw({ op: VMOpCode_1.VMOpCode.GET_SUPER_PROP, arg: 0 });
            return;
        }
        (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.expression(node.object);
        if (node.computed) {
            (_c = context.dispatch) === null || _c === void 0 ? void 0 : _c.expression(node.property);
            if (node.optional) {
                builder.getComputedOptional();
            }
            else {
                builder.getComputed();
            }
        }
        else {
            if (NodeGuards_1.NodeGuards.isIdentifierNode(node.property)) {
                const propIndex = context.constantPool.add(node.property.name);
                const opcode = node.optional ? VMOpCode_1.VMOpCode.GET_OPTIONAL : VMOpCode_1.VMOpCode.GET_PROP;
                builder.emitRaw({ op: opcode, arg: propIndex });
            }
        }
    }
};
exports.VMMemberAccessCompiler = VMMemberAccessCompiler;
__decorate([
    (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMCompilerUtils),
    __metadata("design:type", typeof (_a = typeof IVMCompilerUtils_1.IVMCompilerUtils !== "undefined" && IVMCompilerUtils_1.IVMCompilerUtils) === "function" ? _a : Object)
], VMMemberAccessCompiler.prototype, "vmCompilerUtils", void 0);
exports.VMMemberAccessCompiler = VMMemberAccessCompiler = __decorate([
    (0, inversify_1.injectable)()
], VMMemberAccessCompiler);
